import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, cellWidth } from '@/components/TableCell';
import ButtonPerssion from '@/routes/ButtonPerssion';

class TableContent extends React.Component {

    _takeColumns = () => ([
        {
            title: '员工账号',
            dataIndex: 'loginName',
            key: 'loginName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '员工姓名',
            dataIndex: 'emplName',
            key: 'emplName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '联系电话',
            dataIndex: 'tel',
            key: 'tel',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '所属部门',
            dataIndex: 'deptName',
            key: 'deptName',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '职位',
            dataIndex: 'position',
            key: 'position',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '角色',
            dataIndex: 'roleNames',
            key: 'roleNames',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: '10%',
            align: 'center',
            render: (text) => (this._renderStatusCell(text))
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            width: cellWidth.normal,
            fixed: 'right',
            render: (text, item) => this._renderActionCell(item.id, item)
        }
    ]);

    _takeDataSource = (dataList) => {
        if (dataList) {
            return dataList;
        } else {
            return [];
        }
    }

    _renderStatusCell = (text) => {
        const stateText = text == 1 ? '正常' : '禁用';
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {stateText}
            </div>
        );
    }

    _renderActionCell = (key, item) => {
        const { tableAction } = this.props;
        const stateText = item.status == 0 ? '启用' : '禁止登陆';
        const state = item.status == 0 ? 'able' : 'disable';
        if (item.isAdmin == 1) {
            return (
                <div className={styles.action}>
                    -
                </div>
            );
        } else {
            return (
                <div className={styles.action}>
                    <ButtonPerssion code='permissions/employee/edit'>
                        <div className={styles.item} onClick={() => tableAction('edit', item)}>编辑</div>
                    </ButtonPerssion>
                    <ButtonPerssion code='permissions/employee/loginswitch'>
                        <div className={styles.item} onClick={() => tableAction(state, item)}>{stateText}</div>
                    </ButtonPerssion>
                    <ButtonPerssion code='permissions/employee/resetpassword'>
                        <div className={styles.item} onClick={() => tableAction('reset', item)}>重置密码</div>
                    </ButtonPerssion>
                </div>
            );
        }
    }

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer} style={{ height: '100%' }}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._takeColumns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    scrollY: PropTypes.string
};

export default TableContent;